import * as React from "react";
import { connect } from "react-redux";
import { selectBalancingFarmEventById } from "../../balancingSelectors/selectBalancingFarmEvents";
import { IdStyles } from "../../less/IdStyles";
import { selectActiveCollectEvent } from "../../selectors/selectCollectEvents";
import { selectAllLeagueRewardsCollected, selectSelectedLeague, } from "../../selectors/selectTournamentInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { EventType } from "../balancing/types/BalancingCore";
import { IdCoopCategory } from "../cooperative/IdCoopCategory";
import { ProbationTimeOverlay } from "../cooperative/ProbationTimeOverlay";
import { actionModalCloseAll, actionModalOpen, actionModalSwapLast, actionModalTabSelect, } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { EventThresholdAction } from "./EventThresholdAction";
import { EventThresholdDescription } from "./EventThresholdDescription";
import { EventThresholdInformation } from "./EventThresholdInformation";
var _LeagueInfo = function (_a) {
    var onOpenMarketMenu = _a.onOpenMarketMenu, onOpenCoopMenu = _a.onOpenCoopMenu, eventType = _a.eventType, eventCompleted = _a.eventCompleted;
    var isCoopLeague = eventType === EventType.CoopLeague;
    // using a ()=> <div> because using React.Fragment causes an error with custom props (id).
    var Wrapper = isCoopLeague
        ? ProbationTimeOverlay
        : function (_a) {
            var children = _a.children;
            return React.createElement("div", { className: "w100 h100" }, children);
        };
    return (React.createElement(Wrapper, { idLoca: IdLoca.joinCoop_blockedTournament_desc },
        React.createElement("div", { className: "tournament-info" },
            React.createElement(EventThresholdDescription, { eventType: eventType, eventCompleted: eventCompleted }),
            React.createElement("div", { className: IdStyles.TournamentThresholdContainer },
                React.createElement("div", { className: "tournament-info__threshold" },
                    React.createElement(EventThresholdInformation, null),
                    React.createElement(EventThresholdAction, { eventId: eventType, onCoopEventClick: onOpenCoopMenu, onPlayerLeagueEventClick: onOpenMarketMenu }))))));
};
var mapState = function (state) {
    var eventId = selectSelectedLeague(state);
    if (eventId === EventType.CollectLeague) {
        var activeEvent = selectActiveCollectEvent(state);
        if (activeEvent != undefined && activeEvent.typeId != undefined) {
            var eventInfo = selectBalancingFarmEventById(activeEvent.typeId);
            eventId = eventInfo != undefined ? eventInfo.type : undefined;
        }
    }
    if (eventId === undefined) {
        return {
            eventCompleted: false,
            eventType: EventType.PlayerLeague,
        };
    }
    return {
        eventCompleted: selectAllLeagueRewardsCollected(state),
        eventType: eventId,
    };
};
var mapDispatch = function (dispatch) { return ({
    onOpenCoopMenu: function () {
        dispatch(actionModalCloseAll());
        dispatch(actionModalOpen(IdModal.Coop));
        dispatch(actionModalTabSelect(IdCoopCategory.CoopProjects));
    },
    onOpenMarketMenu: function () {
        dispatch(actionModalSwapLast(IdModal.Market));
    },
}); };
export var LeagueInfo = connect(mapState, mapDispatch)(_LeagueInfo);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueInfo.tsx
// module id = 608
// module chunks = 3